<template>
<div>

<v-dialog persistent max-width="800" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="settings.visible" transition="v-fade-transition" :hide-overlay=false scrollable>
<v-card class="show-print">
    <v-card-title style="padding:0">
        <v-toolbar dark flat dense class="primary">
            <v-toolbar-title class="white--text">{{dialogTitle || 'Send Email'}}</v-toolbar-title><v-spacer/>
            <v-btn @click="minimise" icon ><v-icon>remove</v-icon></v-btn>
            <v-menu left offset-y>
                <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon ><v-icon>more_vert</v-icon></v-btn>
                </template>
                <v-list>
                    <a :href="`/templates/${template.key}`" target="_blank" class="transparent">
                    <v-list-item @click="1">
                        <v-list-item-title>Open this Template</v-list-item-title>
                    </v-list-item>
                    </a>
                    <v-list-item @click="">
                        <a class="transparent" :href="mailToLink" target="_blank">
                        <v-list-item-title>Send via my normal Email</v-list-item-title>
                        </a>
                    </v-list-item>
                    <v-list-item @click="sendTestEmail">
                        <v-list-item-title>Send a Test Email</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
    </v-card-title>
    <v-card-text style="padding:10px;">
        <div style="height:100%;max-height:100%;display:flex;flex-direction:column">
                <div style="display:flex">
                    <div class="recipient-heading">To</div>
                    <div style="flex-grow:1">
                        <ContactAutocomplete :key="1" v-model="email.to" :items="contactsWithEmail" @change="mergeGreeting"/>
                    </div>
                    <div class="pa-1 recipient-heading" >
                        <div class="hoverable clickable rounded full-height pr-2 pt-1" :class="{'blue-hilight': hasRecipientsCopied}" @click="showCC = !showCC">
                            CC
                        </div>
                    </div>
                </div>


                <div v-if="showCC" style="display:flex">
                    <div class="recipient-heading">Cc</div>
                    <div style="flex-grow:1">
                        <ContactAutocomplete v-model="email.cc" :items="contactsWithEmail"/>
                    </div>
                    <div class="recipient-heading">Bcc</div>
                    <div style="flex-grow:1">
                        <ContactAutocomplete v-model="email.bcc" :items="contactsWithEmail"/>
                    </div>

                </div>

                <!-- Subject Section -->

                <div style="display:flex;">

                    <v-text-field v-model="email.subject" label="Subject" single-line hide-details style="margin:0px 20px 0px 20px;font-size:14px;" @change="subjectChanged"/>

                    <div class="pt-2" style="width:70px">

                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon text color="grey">
                                <v-badge color="grey lighten-1">
                                    <span slot="badge">{{templates.length}}</span>
                                    <v-icon>more</v-icon>
                                </v-badge>

                            </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="template in templates" @click="selectTemplate(template)" :key="template.key">
                                    <v-list-item-title>{{template.name}}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                    </div>
                </div>

                    <HtmlEditor v-model="email.body" />


                <!-- Attachments bar -->
                <div v-if="showAttachments" >
                    <v-combobox v-model="email.attachments" :items="files" single-line hide-details label="Attachments" chips multiple return-object item-text="fileName" style="margin:0px 20px 0px 20px"/>
                </div>
        </div>
    </v-card-text>
    <v-card-actions>
        <div style="display:flex;width:100% ">
                <div style="padding:3px;flex-grow:1" xxxclass="v-box clickable">
                    <v-tooltip v-if="from.special" top>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon>
                            <v-icon color="primary">alternate_email</v-icon>
                        </v-btn>
                        </template>
                        <span>Sending via {{from.email}}</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon @click="showAttachments = !showAttachments">
                            <v-icon color="grey darken-1">attach_file</v-icon>
                        </v-btn>
                        </template>
                        <span>Attachments</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon @click="urgent = !urgent">
                            <v-icon v-if="urgent" color="primary">notifications</v-icon>
                            <v-icon v-else color="grey lighten-1">notifications</v-icon>
                        </v-btn>
                        </template>
                        <span>Alert by SMS</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon @click="print">
                            <v-icon color="grey lighten-1">print</v-icon>
                        </v-btn>
                        </template>
                        <span>Print email</span>
                    </v-tooltip>
                    <span v-if="urgent" class="grey--text">SMS will also be sent</span>
                    <span v-if="validationErrors" class="red--text" v-html="validationErrors"></span>
                </div>

                <div style="padding:3px;min-width:220px;" class="text-right">

                    <v-btn text @click="cancelClicked">Cancel</v-btn>

                    <!-- Dummy Button -->
                    <template v-if="this.validationErrors">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text disabled>Send</v-btn>
                            </template>
                            <div v-html="this.validationErrors"></div>
                        </v-tooltip>
                    </template>

                    <!-- Send Button  -->
                    <template v-else>
                        <v-btn text @click="sendClicked">{{sendLabel}}</v-btn>
                    </template>
                </div>
        </div>
    </v-card-actions>
</v-card>
</v-dialog>

<!-- Minimised version -->

<div v-if="settings.minimised" style="position:absolute;bottom:0;right:0;width:300px;">
    <v-toolbar dark flat dense class="primary">
        <v-toolbar-title class="white--text">{{dialogTitle}}</v-toolbar-title><v-spacer/><v-btn @click="maximise" icon ><v-icon>web_asset</v-icon></v-btn>
    </v-toolbar>
</div>

</div>
</template>

<script>
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import 'firebase/database'
    import FirebaseHelpers from '../helpers/FirebaseHelpers'
    import DataHelpers from '../helpers/DataHelpers'
    import Utilities from '../helpers/Utilities'
    import StringHelpers from '../helpers/StringHelpers'
    import MergeHelpers from '../helpers/MergeHelpers'
    import ContactHelpers from '../helpers/ContactHelpers'
    import NumberHelpers from '../helpers/NumberHelpers'
    import AlertHelpers from '../helpers/AlertHelpers'
    //
    import ElementHelpers from '../helpers/ElementHelpers'
    import LogHelpers from '../helpers/LogHelpers'
    import ArrayHelpers from '../helpers/ArrayHelpers'
    import FileHelpers from '../helpers/FileHelpers'
    import EmailHelpers from '../helpers/EmailHelpers'
    // import { VueEditor } from "vue2-editor"
    import ContactAutocomplete from '../ui-elements/ContactAutocomplete'
    import HtmlEditor from '../ui-elements/HtmlEditor'


    var db = firebase.database()
    var templatesRef = db.ref('empty')



    export default {
    components: {
        // VueEditor,
        ContactAutocomplete,
        HtmlEditor,
    },

    props:
    {
        settings: Object,
        /*
            Expects: visible, group, template
        */
        email: Object,
        /*
            Expects: to, cc, bcc, body, attachments,
        */
        returnObject: Object,
    },

    data() {
        return {
            userContact: {},
            // fromAddress: null,
            // isCustomFromAddress: false,
            emailBcc: null,
            mostRecentGreeting: null,
            showCC: false,
            showAttachments: false,
            automaticSubject: false,
            preferences: {
                cc: '',
                bcc: '',
                signature: '',
                broker: false,
            },
            template: {key:null},
            urgent: false,
            // sendViaSendgrid: true,
            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }, {list: "check"}],
                ["link", "blockquote"],
                [{ 'color': [] }, { 'background': [] }],
                ['clean']
            ]
        }
    },

    computed: {
        from() {
            if(this.settings.sent) {
                return {
                    email: this.email.from,
                    name: this.email.fromName,
                    special: true,
                }
            }

            if(this.broker && this.preferences.broker) {
                return {
                    email: this.broker.email,
                    name: ContactHelpers.fullName(this.broker),
                    special: true,
                }
            }

            return {
                email: this.userContact.email || this.user.email,
                name: ContactHelpers.fullName(this.user),
                special: (this.user.email !== this.userContact.email)
            }

        },

        user() {
            return this.$store.getters.user
        },

        broker() {
            const brokerEls = ElementHelpers.contactElementsForRole('Broker', this.elements)
            if(brokerEls.length)
                return brokerEls[0].contact
            else
                return null
        },

        brokerEmail() {
            return (this.broker ? this.broker.email : '')
        },

        mailToLink() {
            const recipient = 'matt@ireland.mx'
            const subject = encodeURIComponent(this.email.subject)
            const body = encodeURIComponent(StringHelpers.removeHtml(this.email.body))
            return `mailto:${recipient}?subject=${subject}&body=${body}`
        },
        sendLabel() {
            if(this.settings.sent)
                return 'Send Again'
            else
                return 'Send'
        },

        attachmentsAsLinks() {
            if(!this.email || !this.email.attachments || this.email.attachments.length == 0)
                return ''
            let str = ''// '<b>Linked Files</b>&nbsp;&nbsp;'
            this.email.attachments.forEach(attachment => {
                str += MergeHelpers.formatFileLink(attachment)
            })
            return str + '<br>'
        },

        mergeFieldsUnresolved() {
            return this.email.body.match(/\[(.*?)\]/) || (this.email.subject || '').match(/\[(.*?)\]/)
        },

        recipientsWithMobiles() {

            return this.email.to.filter(o => o.mobile)
        },

        recipientsWithFaxes() {
            if(!this.email.to)
                return []
            return this.email.to.filter(o => o.fax)
        },

        validationErrors() {
            let errors = []
            if(this.mergeFieldsUnresolved)
                errors.push("There are unknown [merge_fields]")
            if(!this.email.subject)
                errors.push("You should provide a subject")
            if(
                (!this.email.to || !this.email.to.length) &&
                (!this.email.cc || !this.email.cc.length) &&
                (!this.email.bcc || !this.email.bcc.length)
            )
                errors.push("You need to provide recipients")
            return errors.join(' + ')
        },

        user() {
            return this.$store.getters.user
        },
        bodyHeight () {
            let height = 340

            if(this.showCC)
                height -= 54

            if(this.showAttachments)
                height -= 54

            return height
        },

        greeting() {
            return ContactHelpers.greetingFromContacts(this.email.to)
        },

        dialogHeight () {
            return window.innerHeight - 150
        },

        elements() {
            return ElementHelpers.getElements()
        },

        fields() {
            return [
                {
                    name: 'sender',
                    value: this.user.firstName
                },
                ...this.elements
            ]
        },

        contactsWithEmail() {
            let contacts = []

            this.$store.getters.transactionContacts.forEach(contact => {
                if(contact.email)
                    contacts.push(contact)
                if( Utilities.isPhoneNumber(contact.fax) ) {
                    let faxContact = ContactHelpers.createFaxContact(contact)
                    contacts.push(faxContact)
                }

            })
            return contacts
            //return this.$store.getters.transactionContacts.filter(o => o.email)
        },

        primaryContactType() {

                if(!this.email.to || this.email.to.length < 1)
                    return 'Contact'

                if(!this.email.to[0].role) {

                    console.error('primaryContactType - no role passed')
                    return
                }
                let contactType = this.email.to[0].role.toLowerCase()
                if(contactType.indexOf('lender') > -1)
                    return 'Lender'
                else if(contactType.indexOf('bdm') > -1)
                    return 'BDM'
                else if(contactType.indexOf('client') > -1)
                    return 'Client'
                else
                    return 'Contact'

        },



        files() {
            return this.elements.filter(o => o.type == 'File')
        },

        templates() {
            let templates  = this.$store.getters.templates
            return templates.filter(o => o.group == this.settings.group)
        },
        hasRecipientsCopied () {
            return ( (this.email.cc && this.email.cc.length) || (this.email.bcc && this.email.bcc.length) )
        },

        dialogTitle() {
            if(this.settings.sent)
                return 'Sent Previously'
            else
                return 'Send Email'
        }

    },

    methods: {

        print() {
            let el = document.querySelector('.vue-html5-editor .content')
            console.log(el.innerHTML)
            Utilities.printHtml(el.innerHTML)
        },

        // Now uses Stringhelpers.removeHtml()
        // strip(html) {
        //     html = html.replace(/<div>/gi, '\n').replace(/\<br\>/gi, '\n').replace(/\<br\/\>/gi, '\n').replace(/\n\n/g, '\n')
        //     var tmp = document.createElement("DIV")
        //     tmp.innerHTML = html
        //     return tmp.textContent || tmp.innerText || ""
        // },

        sendClicked() {
            let email = this.createEmail()

            if(this.email.to)
                email.to = this.email.to.map(o => this.determineEmail(o))
            if(this.email.cc)
                email.cc = this.email.cc.map(o => this.determineEmail(o))
            if(this.email.bcc)
                email.bcc = this.email.bcc.map(o => this.determineEmail(o))

            //new get from contact record or user record...
            email.from = this.from.email

            email.reply = email.from
            email.fromName = this.from.name
            email.body = this.email.body
            // email.body = this.attachmentsAsLinks +  this.email.body
            email.subject = this.email.subject

            email.attachments = (this.email.attachments || []).map(attachment => {
                return {
                    path: attachment.value,
                    name: attachment.originalName || attachment.filename || attachment.name || FileHelpers.fileNameFromStoragePath(attachment.value),
                }
            })


            const toObjArray = email.to.map(s => {
                return {email: s}
            })
            const attachmentArray = email.attachments.map(o => {
                return {
                    filename: o.name,
                    path: o.path
                }
            })
            const emailObj = {...email, provider: 'smtp2go', to: toObjArray, attachments: attachmentArray}
            const logId = EmailHelpers.queueEmail( emailObj )
            if(this.preferences.copyMe) {
                const copyMeObj = {...emailObj}
                copyMeObj.to = [{email: DataHelpers.getUserEmail()}]
                copyMeObj.cc = []
                copyMeObj.bcc = []
                copyMeObj.subject = 'TACO-SENT: ' + copyMeObj.subject
                copyMeObj.body = "*** Copy of email sent to " + emailObj.to.map(o => o.email).join(',')
                    + " ***" + '<br/><br/>' + copyMeObj.body

                EmailHelpers.queueEmail( copyMeObj )
            }


            this.$root.$monitorMail(logId)
            //AlertHelpers.showAlert('Email Sent', {timeout: 1500})
            this.$emit('sent', this.returnObject)
            this.settings.visible = false
            return


        },

        determineEmail(obj) {
            if(!obj)
                return ''
            if(typeof obj == 'string')
                return obj
            if(obj.email)
                return obj.email
            return ''
        },

        logEmail(email, result) {
            let logItem = LogHelpers.createLogItem()

            logItem.result = result

            logItem.userKey = DataHelpers.getUserId()
            logItem.type = 'email'
            logItem.tenantKey = DataHelpers.getTenantKey()

            const transactionDetails = DataHelpers.getTransactionDetails()
            if(transactionDetails) {
                logItem.transactionKey = transactionDetails.key
                logItem.transactionClients = transactionDetails.clients
            }

            if(this.returnObject) {

                logItem.elementKey = this.returnObject.key
                logItem.elementTitle = this.returnObject.title

                logItem.elementIndex = logItem.transactionKey + '/' + logItem.elementKey
            }

            logItem.email = email

            LogHelpers.log(logItem)
        },

        sendSMS() {
            DataHelpers.getSettings('sms').then(settings => {
                this.recipientsWithMobiles.forEach(recipient => {
                    let message = settings.prefix + ' Hi ' + recipient.firstName + ', I have just sent you an important email. Give me a call if you need to. ' + settings.suffix
                    Utilities.sendSMS(message, recipient.mobile)
                })
            })
            this.urgent = false
        },

        createEmail() {

            return {
                to: null,
                cc: null,
                bcc: null,
                body: ''
            }
        },

        minimise() {
            this.settings.minimised = true
            this.settings.visible = false
        },

        maximise() {
            this.settings.visible = true
        },

        cancelClicked() {
            this.closeDialog()
        },

        closeDialog() {
            this.settings.visible = false
        },

        // updateBody(val) {
        //     this.email.body = val
        // },

        templatesClicked() {
            //console.log(this.templates)

        },

        selectTemplate(template) {
            if(!template) {
                AlertHelpers.showAlert('No template provided')
                return
            }

            //temporary to clean divs from old editor
            let newTemplate = {...template}
            // newTemplate.body = newTemplate.body.replace(/<div>/gi, '').replace(/<\/div>/gi, '')
            //console.log(newTemplate.body)


            this.template = newTemplate
            this.merge()
            this.mostRecentGreeting = null
            this.mergeGreeting()
            //console.log(this.email.body)

        },

        merge() {
            console.log('emailDialog > merge')

            let options = {element: this.returnObject}

            if(this.settings.customFields) {
                options = {...options, ...this.settings.customFields}
            }

            this.email.subject = MergeHelpers.merge(this.template.subject, this.fields, options)
            this.automaticSubject = (!this.email.subject)
            this.setAutomaticSubject()
            //get {text: xxxxx, attachments: []}

            let mainMergeResults = MergeHelpers.mergeAndAttach(this.template.body, this.fields, options)

            //temp to remove divs
            let signature = this.preferences.signature
            console.log('signature is....' + signature)

            //let signature = signature.replace(/<div>/gi, '').replace(/<\/div>/gi, '')

            this.email.body = mainMergeResults.text + '<br><br>' +  signature

            this.email.attachments = mainMergeResults.attachments.map(attachment => {

                return {
                    name:attachment.name,
                    value:attachment.path,
                    title:attachment.name,
                    fileName:attachment.fileName,
                }
            }).concat(this.email.attachments)
            this.showAttachments = (this.email.attachments.length > 0)
        },

        subjectChanged() {
            setTimeout( () => {
                if(this.email.subject)
                    this.automaticSubject = false
                else {
                    this.automaticSubject = true
                    this.setAutomaticSubject()
                }
            },200)
        },

        setAutomaticSubject() {
            if(!this.automaticSubject)
                return
            if(this.primaryContactType == 'Client')
                this.email.subject = 'Loan Update'
            else if(this.primaryContactType == 'Lender')
                this.email.subject = MergeHelpers.merge('[loan_reference]' , this.fields)
            else if(this.primaryContactType == 'BDM')
                this.email.subject = MergeHelpers.merge('[loan_reference] - [client]' , this.fields)
            else
                this.email.subject = MergeHelpers.merge('[client]' , this.fields)
        },

        mergeGreeting() {

            if(!this.greeting)
                return

            if(this.mostRecentGreeting) {
                this.email.body = this.email.body.replace(this.mostRecentGreeting, this.greeting)
            } else {
                this.email.body = this.email.body.replace('[greeting]', this.greeting)
            }

            this.mostRecentGreeting = this.greeting
        },

        resolveContacts(contactArray) {
            if(!contactArray)
                return []
            let newArray = []

            contactArray.forEach(contact => {
                if(typeof contact == 'string') {
                    newArray.push({
                        email: contact,
                        key: DataHelpers.getKey(),
                        fullName: contact,
                    })

                } else if (!contact.key && !contact.fullName) {
                    newArray.push({
                        email: contact.email,
                        key: DataHelpers.getKey(),
                        fullName: contact.email,
                    })
                }
                else
                    newArray.push(contact)
            })
            return newArray
        },

        async initialiseDialog() {

            this.email.to = this.resolveContacts(this.email.to)
            this.email.cc = this.resolveContacts(this.email.cc)
            this.email.bcc = this.resolveContacts(this.email.bcc)

            if(this.settings.sent) {
                // this.fromAddress = this.email.from
                this.email.attachments.forEach(attachment => {
                    this.$set(attachment, 'value', attachment.path)
                    this.$set(attachment, 'name', attachment.filename)
                    this.$set(attachment, 'name', attachment.filename)
                    this.$set(attachment, 'title', attachment.filename)
                })
                return
            }

            if(!this.email.attachments)
                this.email.attachments = []

            if(this.email.attachments.length)
                    this.showAttachments = true



             //load preferences...

            const prefs = await DataHelpers.getSettings('email')


            this.preferences.signature = prefs.signature || ''
            this.preferences.cc =  prefs.cc || ''
            this.preferences.bcc = prefs.bcc || ''
            this.preferences.broker = prefs.broker || ''
            this.preferences.copyMe = prefs.copyMe || false

            this.userContact =  await ContactHelpers.fetchContact(DataHelpers.getUserId()) || {}

            if(prefs.cc) {
                if(!this.email.cc)
                    this.email.cc = []
                let preferredCCArr = prefs.cc.split(',')
                preferredCCArr.forEach( (preferredCCEntry, index) => {
                    let contact = this.contactsWithEmail.find(o => o.email.toLowerCase() == preferredCCEntry.trim().toLowerCase())
                    if(contact)
                        this.email.cc.push(contact)
                    else
                        this.email.cc.push({email:preferredCCEntry, key:'_ccAddress' + index})
                })

            }

            if(prefs.bcc) {
                if(!this.email.bcc)
                    this.email.bcc = []
                let preferredBCCArr = prefs.bcc.split(',')
                preferredBCCArr.forEach( (preferredBCCEntry, index) => {
                    let contact = this.contactsWithEmail.find(o => o.email.toLowerCase() == preferredBCCEntry.trim().toLowerCase())
                    if(contact)
                        this.email.bcc.push(contact)
                    else
                        this.email.bcc.push({email:preferredBCCEntry, key:'_bccAddress' + index})
                })

            }

            this.$store.dispatch('loadTemplates').then( () => {
                let template = this.templates.find(o => o.name == (this.settings.template) )

                    setTimeout(() => {
                        //delayed to allow sender to load...
                        this.selectTemplate(template)
                    },100)
            })

        },

        resetDialog() {
            setTimeout( () => {
                this.email.to = null
                this.email.cc = null
                this.email.bcc = null
                this.email.body = ''
                this.email.attachments = []
                this.settings.sent = false
                this.settings.showCC = false
                this.mostRecentGreeting = null
            },500)
        },

        sendTestEmail() {
            //EmailHelpers.sendTest()
            var clientId = '729201786634-ehmhjpt1vs7scb5rr60tuc5ru2cc5pvd.apps.googleusercontent.com'
            var apiKey = 'AIzaSyDpqlA9Rm67VW6jnC-ZzxYZZNyW3CekVMQ';
            var scopes =
                'https://www.googleapis.com/auth/gmail.readonly '+
                'https://www.googleapis.com/auth/gmail.send'

                gapi.client.setApiKey(apiKey);

                gapi.auth.signOut()


                gapi.auth.authorize({
                    client_id: clientId,
                    scope: scopes,
                    //immediate: true
                }, function(result) {

                    consule.log(result)
                })
        },



    },

    watch: {
        'settings.visible': function (newVal) {
            if(newVal) {
                if(!this.settings.minimised)
                    this.initialiseDialog()
                else
                    this.settings.minimised = false
            }
            if(!newVal && !this.settings.minimised)
                this.resetDialog()
        },

        'email.to': function (newVal) {
            this.setAutomaticSubject()
        }
    },

    }


</script>


<style scoped>

.v-box {
    background-color:white;
    height:57px;
    color: #555;
}

.recipient-heading {
    width: 45px;
    padding:10px;
    text-align:right;
}



</style>


// WEBPACK FOOTER //
// EmailDialog.vue?16abb600